import { Injectable } from '@angular/core';
import { OrderUiService } from '../types/interfaces';

@Injectable()
export class NoopOrderUiService implements OrderUiService {
  tryShowItaOrderTutorial() {}
}
